export enum TabletopCanvasInputMode {
    NAVIGATE_CANVAS,
    DRAW_TERRAIN,
    MANIPULATE_TERRAIN,
    CREATE_TOKEN,
    MANIPULATE_TOKEN,
}
